import { useTranslation } from 'react-i18next';
import imgSpaIsClosing from 'assets/images/spa-is-closing/spa-is-closing.png';
import Styles from 'spa-is-closing/spa-is-closing.module.scss';
import { MobileAppLinks } from 'app/MobileAppLinks';

type Props = {
  title: string;
  description: JSX.Element;
  link?: {
    text: string;
    onClick: () => void;
  };
};

export const SpaClosingTemplate = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div className={Styles.container}>
      <img src={imgSpaIsClosing} alt="" />
      <p className={Styles.title}>{props.title}</p>
      {props.description}
      {props.link && (
        <p onClick={props.link?.onClick} className={Styles.link}>
          {props.link?.text}
        </p>
      )}
      <MobileAppLinks
        message={t('SpaClosingProcedure.DiscoverApps')}
        className={Styles.mobileAppLinks}
      />
    </div>
  );
};
